(function ( $ ) {
  var elements = 'input[type="text"], input[type="tel"], input[type="radio"], input[type="checkbox"], select, textarea';
  $.fn.FormCache = function(conf) {
      if (conf && conf.elements) elements = conf.elements;
      function getData(key) {
        var data;
        if(typeof(Storage)!=="undefined"){
          if(localStorage[key]) {
              data = JSON.parse(localStorage[key]);
          }
          
          if(!data) {
              localStorage[key] = JSON.stringify({});
              data = JSON.parse(localStorage[key]);
          }
        } else {
          if (!document[key]) {
            document[key] = {};
          } 

          data = document[key];
        }

        return data;
      }

      function storeData(key, data) {
        if(typeof(Storage)!=="undefined"){
          localStorage[key] = JSON.stringify(data);
        } else {
          document[key] = data;
        }
      }

      function onChange(event) {
          var input = $(event.target);
          var key = input.parents('form:first').attr('id');
          var data = JSON.parse(localStorage[key]);
          
          if(input.attr('type') == 'radio' || input.attr('type') == 'checkbox') {
              data[input.attr('id')] = input.is(':checked');
          }else {
              data[input.attr('name')] = input.val();
          }
          
          storeData(key, data);
      }
      
      return this.each(function() {    
          var element = $(this);
          
          var key = element.attr('id');
          var data = getData(key);
         
          element.find(elements).change(onChange);
          element.find(elements).each(function(){
              
            var input = $(this);
            var value = data[input.attr('name')];
            if(input.attr('type') == 'radio' || input.attr('type') == 'checkbox') {
              value = data[input.attr('id')];
              if(value) {
                  input.prop('checked', true);
              } else {
                  input.removeAttr('checked');
              }
            } else {
                input.val(value);
            }

            // call change to make sure hs registers change
            if (value) input.change();
              
          });
      });
  };     
}( jQuery ))